<template>
  <div :class="classes">
      <pt-page-title title="CPS缴费记录" isSearch  @search="search" @emptySearch="emptySearch" :searchKey="searchKey" @searchNo="searchNo"></pt-page-title>
      <pt-page-factor-filter :labels="CPSPaymentTabs" v-model="filterCPS" isQueryRouter ref="filter" @Filter="Filter">
        <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportCPS" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportCPSHistory">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-cps-payment-table :tabeLabels="cpsPaymentTableLabels" :pageSize="pageSize" :paramsData="paramsData" ref="table" :isFromRouter="isFromRouter"></pt-cps-payment-table>
  </div>
</template>

<script>
// 组件class前缀
import ptCpsPaymentTable from './pt-cps-payment-table/withData'
import { cpsPaymentTableLabels, CPSPaymentTabs } from './cps-payment-option'
import { emptyObject } from '@/utils/lifebankUtils'
import { cashCount } from '@/utils/formUtils'
const prefixCls = 'pt-cps-payment'
export default {
  name: 'pt-cps-payment',
  components: {
    ptCpsPaymentTable
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    isValidateCompany: {
      type: Boolean,
      default: false
    },
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      cpsPaymentTableLabels: cpsPaymentTableLabels,
      CPSPaymentTabs: CPSPaymentTabs,
      filterCPS: {},
      paramsData: {},
      searchKey: '',
      isFromRouter: false
    }
  },
  watch: {
    isValidateCompany (val) {
      let hasOrg = false
      this.CPSPaymentTabs.forEach(item => {
        if (item.value === 'orgId') {
          hasOrg = true
        }
      })
      if (val) {
        let companyObj = {
          label: '分公司',
          type: 'select',
          value: 'orgId',
          options: [],
          props: {
            label: 'name',
            value: 'id'
          },
          clearable: true
        }
        if (!hasOrg) {
          if (this.companyList.length <= 0) {
            this.CPSPaymentTabs.push(companyObj)
          } else {
            companyObj.options = this.companyList
            this.CPSPaymentTabs.push(companyObj)
          }
        }
      }
    },
    companyList: {
      handler: function (val) {
        if (val.length > 0) {
          if (this.isValidateCompany) {
            this.CPSPaymentTabs.forEach(item => {
              if (item.value === 'orgId') {
                item.options = val
              }
            })
          }
        }
      },
      deep: true
    }
  },
  methods: {
    searchNo (val) {
      this.searchKey = val
    },
    exportCPSHistory () {
      this.$router.push('/export-history/mall_order_bill?name=mall_order_bill')
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.filterCPS)
      emptyObject(this.paramsData)
      //   this.paramsData.searchKey = val
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (!isFromRouter) {
        this.searchKey = null
        if (this.filterCPS.searchKey) {
          this.$delete(this.filterCPS, 'searchKey')
        }
      }
      this.filterData()
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCPS)
      }
      this.paramsData = JSON.parse(JSON.stringify(this.filterCPS))
    },
    // 筛选数据处理
    filterData () {
      for (var key in this.filterCPS) {
        if (!this.filterCPS[key]) {
          this.$delete(this.filterCPS, key)
        }
        if (key === 'paymetTime') {
          this.$delete(this.filterCPS[key], 'index')
          this.filterCPS = { ...this.filterCPS, ...this.filterCPS[key] }
          this.$delete(this.filterCPS, key)
        } else if (key === 'payAmount') {
          this.filterCPS.payAmountStart = cashCount(this.filterCPS[key].payAmountStart)
          this.filterCPS.payAmountEnd = cashCount(this.filterCPS[key].payAmountEnd)
          this.$delete(this.filterCPS, 'payAmount')
        }
      }
    },
    cleanParams () {
      emptyObject(this.filterCPS)
      this.Filter()
    },
    exportCPS () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.filterData()
          this.filterCPS.searchKey = this.searchKey || null
          this.$emit('exportCPS', JSON.parse(JSON.stringify(this.filterCPS)))
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
